import React from "react";
import { REVIEWS, VIDEO_TESTIMONIALS, BUSINESS } from "../mock";
import { Reveal, SectionEyebrow, StarRating, CtaButton } from "./common";
import { VideoCard } from "./VideoCard";
import { ExternalLink } from "lucide-react";

export const VideoTestimonials = () => (
  <section className="bg-brand-ivory py-20">
    <div className="mx-auto max-w-5xl px-5 text-center md:px-8">
      <Reveal>
        <SectionEyebrow center>Real Clients · Real Words</SectionEyebrow>
        <h2 className="mt-4 font-serif text-3xl text-brand-ink md:text-4xl">Hear it straight from our clients</h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-3">
        {VIDEO_TESTIMONIALS.map((v, i) => (
          <Reveal key={i} delay={i * 90}>
            <VideoCard poster={v.poster} youtubeId={v.youtubeId} quote={v.quote} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const Reviews = () => (
  <section className="bg-brand-cream/50 py-20">
    <div className="mx-auto max-w-6xl px-5 md:px-8">
      <Reveal className="text-center">
        <SectionEyebrow center>Real Clients · Real Reviews</SectionEyebrow>
        <h2 className="mt-4 font-serif text-3xl text-brand-ink md:text-4xl">What our clients say</h2>
        <div className="mt-4 flex items-center justify-center gap-2">
          <span className="font-serif text-2xl font-semibold text-brand-ink">{BUSINESS.rating}</span>
          <StarRating />
          <span className="font-sans text-sm text-brand-muted">{BUSINESS.reviewCount} Google reviews</span>
        </div>
      </Reveal>
      <div className="mt-10 columns-1 gap-5 sm:columns-2 lg:columns-3 [&>*]:mb-5">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={(i % 3) * 70}>
            <div className="break-inside-avoid rounded-2xl bg-white p-6 shadow-[0_16px_45px_-28px_rgba(35,35,32,0.45)] ring-1 ring-brand-cream">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-sage/10 font-serif text-lg font-semibold text-brand-sage">
                  {r.initial}
                </div>
                <div>
                  <p className="font-sans text-sm font-semibold text-brand-ink">{r.name}</p>
                  <p className="font-sans text-xs text-brand-muted">{r.when}</p>
                </div>
              </div>
              <StarRating size={14} className="mt-3" />
              <p className="mt-3 font-sans text-sm leading-relaxed text-brand-muted">“{r.text}”</p>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="mt-10 flex flex-col items-center gap-5">
        <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 font-sans text-sm font-semibold text-brand-sage underline underline-offset-4 transition hover:text-brand-sagedark">
          Read all {BUSINESS.reviewCount} reviews on Google <ExternalLink size={14} />
        </a>
        <CtaButton toForm>Claim My Spot</CtaButton>
      </div>
    </div>
  </section>
);
